export const getNavigationItems = (isPro) => [
  {
    path: "/About",
    title: "About",
    label: "About us",
  },
  {
    path: "/view/evidence",
    title: "Trip Evidence",
    label: "Trip Evidence",
  },
  {
    path: "https://blog.tripdatabase.com/",
    title: "Blog",
    label: "Blog",
    external: true,
    target: "_blank",
    rel: "noopener noreferrer",
  },
  {
    path: "/ask",
    title: "AskTrip",
    label: "AskTrip",
    className: "ask-gradient text-light px-3 py-1 my-1 rounded-pill",
  },
  ...(!isPro ? [{
    path: "/Why",
    title: "Go Pro",
    label: "Go Pro",
  }] : []),
];